import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import LegalRemarksPageUI from './LegalRemarksPageUI.js'

class LegalRemarksPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      legalRemarksList: null,
      objectCode: null,
      objectId: null,
      createMode: false,
      updateRemarksMode: false
    }
  }

  render() {
    return (
      <LegalRemarksPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        objectCode={this.state.objectCode}
        objectId={this.state.objectId}
        createMode={this.state.createMode}
        updateRemarksMode={this.state.updateRemarksMode}
        onCancelRemarksClick={() => { this.setState({ createMode: false, updateRemarksMode: false }) }}
        onCreateRemarksClick={this.onCreateRemarksClick}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        selectedDate={this.state.selectedDate}
        selectedActionDateISO={this.state.selectedActionDateISO}
        selectedActionStatus={this.state.selectedActionStatus}
        selectedRemarks={this.state.selectedRemarks}
        selectedAction={this.state.selectedAction}
        selectedRemarksId={this.state.selectedRemarksId}
        legalRemarksList={this.state.legalRemarksList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getLegalRemarks(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getLegalRemarks(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/legal/remarks`,
      cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'legal'),
      callback: this.getLegalRemarksCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLegalRemarksCallback = (response) => {
    this.setState({ errorList: response.errorList, legalRemarksList: response.remarksList })
  }

  onCreateRemarksClick = (event) => {
    let objectCode = event.currentTarget.getAttribute('data-object-code')
    let objectId = event.currentTarget.getAttribute('data-object-id')
    this.setState({
      createMode: true,
      objectCode: 'legal',
      objectId: 'legal'
    })
  }

  onUpdateRemarksClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    let date = event.currentTarget.getAttribute('data-date')
    let selectedRemarks = event.currentTarget.getAttribute('data-remarks')
    let selectedAction = event.currentTarget.getAttribute('data-action')
    let selectedActionStatus = event.currentTarget.getAttribute('data-action-status')
    let selectedActionDateISO = event.currentTarget.getAttribute('data-action-date')
    let selectedRemarksId = event.currentTarget.getAttribute('data-remarks-id')

    this.setState({
      updateRemarksMode: true,
      objectId: objectId,
      createMode: false,
      selectedDate: date,
      selectedRemarks: selectedRemarks,
      selectedAction: selectedAction,
      selectedActionStatus: selectedActionStatus,
      selectedActionDateISO: selectedActionDateISO,
      selectedRemarksId: selectedRemarksId
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.state.loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanRemarks(this.props.match.params.loanId, 'legal'))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
      this.getLegalRemarks(context)
    }
    else {
      this.setState({
        loan: null,
        legalRemarksList: null,
        errorList: null
      })
      this.getLoan(context)
      this.getLegalRemarks(context)
    }
  }
}

export default withRouter(LegalRemarksPageSF)
